export default "dist/images/block-feature-grid-plain.778ba63.png";